import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IAffiliateProfileUpdatePayload, IAffiliateProfileUpdateResponse } from '../types';
import {
  AFFILIATE_PROFILE_UPDATE_API_URL,
  AFFILIATE_PROFILE_UPDATE_MUTATION,
  AFFILIATES_APPROVED_PROFILE_PERMISSIONS,
} from '../constants';

export default function useAffiliateProfileUpdateMutation(): IContextMutationResult<IAffiliateProfileUpdateResponse, Error, IAffiliateProfileUpdatePayload> {
  const { fetchPut } = useRestClient();

  return useContextMutation<IAffiliateProfileUpdateResponse, Error, IAffiliateProfileUpdatePayload>({
    mutationKey: [AFFILIATE_PROFILE_UPDATE_MUTATION],
    mutationFn: ({ id, affiliate }) => fetchPut<IAffiliateProfileUpdateResponse>(
      AFFILIATE_PROFILE_UPDATE_API_URL,
      affiliate,
      {
        permission: AFFILIATES_APPROVED_PROFILE_PERMISSIONS.EDIT,
        urlParams: {
          id,
        },
      },
    ),
  });
}
